import Events from 'tf-events-1';
import hierarchy from './hierarchy';

const eventsBySeId = {}

const initEvents = instance => {
	
	if(eventsBySeId[instance.id]){
		return eventsBySeId[instance.id];
	}

	const events = Events({hierarchy});
	eventsBySeId[instance.id] = events;

	return events;
}

export default initEvents;